import React, { Component, Fragment } from 'react';
import axios from 'axios'
import { ValidatorForm,TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import Autocomplete from '@mui/material/Autocomplete';
import PageHeader from "../helper/PageHeader";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  root: {
    '& a': {
        color: 'white'
    }
  }
});

class TrainingByEmployer extends Component {
   
  constructor(props) {
    super(props);
    this.submitting =  false;
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem('accessToken');
    this.state = {
      employers: [],
      employer: {id: "", name:""},
      isCreditAvailable: false,
      supervisorLastName : '',
      info: null
    }
  }
   
  onEmployerSelect = (name, value) => {
    let selected = value;

    if (selected === null) {
      this.setState({
          employer: ''
      });
      return;
    }
    this.setState({ employer: JSON.parse(JSON.stringify(selected)) });
  }

  onLookup = (event) => {
    console.log(this.state.employer);
    let url = '/api/employerTraining/search/' + this.state.employer.id +
    '?employerName=' + this.state.employer.name 
    + '&userFirstName=' + this.user.first_name
    + '&userLastName=' + this.user.last_name
    + '&userMiddleName=' + this.user.middle_name
    + '&userDOB=' + this.user.DOB
    + '&supervisorLastName=' + this.state.supervisorLastName;

   axios(url, {
      method: 'GET',
      headers: {
        'Authorization': this.token
      }
    }).then(((result) => {
      console.log(result);
      if (result.status === 200) {
        this.setState({
          employerTrainingID: result.data.record.id,
          isCreditAvailable: true,
          info: this.props.t('TrainingByEmployer.AcceptTheCredit')
        });
      } else {
        this.setState({
          isCreditAvailable: false,
          info: this.props.t('TrainingByEmployer.CannotFindCredit')
        });
      }
    })).catch(error => {
      this.setState({
        isCreditAvailable: false,
        error: error.message
      });
    });
  }

  onDeclineCredit = event => {
    this.setState({ 
      isCreditAvailable: false,
      info: '' 
    })
  }

  onAcceptCredit =  async(event) => {
    event.preventDefault()
    console.log(this.submitting)
    if (!this.submitting) {
      this.submitting = true;
     
      try {
        await axios.post('/api/employerTraining/claimCredit', {
          username : this.user.username,
          ID : this.state.employerTrainingID,
          notes: "Claim credit from employer " + this.state.employer.name 
          },
          {
            headers: {
            'Authorization': this.token
            }
          }
        );
        this.props.history.push('/dashboard/trainingMain');
      } catch(error) {
        this.setState({
          isCreditAvailable: false,
          error: error.message
        });
      }
      this.submitting = false;
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  hideInfo = () => {
    this.setState({ info: '' })
  }

  componentDidMount() {
    // retrieve the list of employers with 'Assign' emplyerTraining records
    let url = '/api/usergroup/list/employer/Assigned';
    axios(url, {
        method: 'GET'
    }).then(res => res.data)
    .then(result => {
      let employers = [];

      if (result.employers.length > 0) {
        result.employers.map((u) =>
            employers.push({ id: u.id, name: u.name, })
        );
        this.setState({
            employers: employers
        });
      }
    }).catch(error => {
        this.setState({ error: error.message });
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <PageHeader
            title={this.props.t('TrainingByEmployer.LookUpEmployer')}
            cancel={this.props.history.goBack}
        />
              
        <ValidatorForm
          noValidate
          onSubmit={this.onLookup}
        >          
          {this.state.info &&
            <div>
                <Alert severity="info" onClose={this.hideInfo}>{this.state.info}</Alert>
                <br />
            </div>
          }
          {this.state.isCreditAvailable &&
            <div>
              <Button variant="contained" color="primary" className={[].join(' ')} onClick={this.onAcceptCredit} > {this.props.t('TrainingByEmployer.Accept')} </Button>
              <Button variant="contained" color="secondary" className={[].join(' ')} onClick={this.onDeclineCredit} > {this.props.t('TrainingByEmployer.Decline')} </Button>
            </div>
          }
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="employers"
                options={this.state.employers}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={this.onEmployerSelect}
                className={[classes.autoComplete].join(' ')}
                renderInput={(params) => <TextValidator {...params}
                  label={this.props.t('TrainingByEmployer.Employer')}
                  value={this.state.employers.length === 0 ? "-" : this.state.employer}
                  validators={['required']}
                  errorMessages={[this.props.t('TrainingByEmployer.ErrorEmployer')]}
                  required
                />}
                disabled={this.state.employers.length === 0}
              />
            </Grid>
            <Grid item xs={5}>
              <TextValidator
                label={this.props.t('TrainingByEmployer.SupervisorLastName')}
                type="text"
                name='supervisorLastName'
                value={this.state.supervisorLastName}
                className={[classes.textField].join(' ')}
                onChange={this.handleChange}
                validators={['required']}
                errorMessages={[ this.props.t('TrainingByEmployer.ErrorSupervisorRequired') , this.props.t('TrainingByEmployer.ErrorValidName') ]}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} style={{ textAlign: "center", alignSelf: "flex-end" }}>
              <Button variant="contained" color="primary" className={[].join(' ')} type="submit" > {this.props.t('TrainingByEmployer.Lookup') } </Button>
            </Grid>
          </Grid>
        </ValidatorForm>
      </Fragment >
    );
  }
}

export default withStyles(styles, { withTheme: true })(withTranslation()(TrainingByEmployer));
